import * as Sentry from "@sentry/react";
/* oxlint-disable no-console */
import { AxiosError } from "axios";

import { ApiError } from "#shared/infra/apiError";

export const toError = (value: unknown): Error => {
  if (value instanceof Error) {
    return value;
  }
  if (typeof value === "string") {
    return new Error(value);
  }
  try {
    return new Error(JSON.stringify(value));
  } catch {
    return new Error(String(value));
  }
};

const extractContext = (value: unknown): Record<string, unknown> | undefined => {
  if (value instanceof ApiError) {
    return { status: value.status, responseData: value.responseBody };
  }
  if (value instanceof AxiosError) {
    return {
      url: value.config?.url,
      method: value.config?.method,
      status: value.response?.status,
      responseData: value.response?.data,
    };
  }
  return undefined;
};

class Logger {
  log = (msg: string) => {
    console.log(msg);
  };

  warn = (msg: string) => {
    console.warn(msg);
  };

  error = (msg: unknown, error?: unknown) => {
    console.error(msg, error);
    const exception = error ?? msg;
    const context = extractContext(exception);
    Sentry.captureException(toError(exception), context ? { extra: context } : undefined);
  };
}

export const logger = new Logger();
